import {
  analyzeConversationAnthropicFunction,
  analyzeConversationFunction,
  generateCompletionAnthropicFunction,
  generateCompletionFunction,
  generateMessageRecommendationsAnthropicFunction,
  generateMessageRecommendationsFunction,
} from "./firebase";
import { ConversationChunk } from "./types";

export const analyzeConversation = async (
  chunks: ConversationChunk[],
  targetName: string
) => {
  // const result = await analyzeConversationFunction({
  //   conversationChunks: chunks,
  //   targetName: targetName,
  // });
  const result = await analyzeConversationAnthropicFunction({
    conversationChunks: chunks,
    targetName: targetName,
  });
  // console.log(result.data.result);

  return result.data.result;
};

export const generateMessageRecommendations = async (
  chunks: ConversationChunk[],
  targetName: string
) => {
  // const result = await generateMessageRecommendationsFunction({
  //   conversationChunks: chunks,
  //   targetName: targetName,
  // });
  const result = await generateMessageRecommendationsAnthropicFunction({
    conversationChunks: chunks,
    targetName: targetName,
  });
  // console.log(result, result.data.result.content);
  // console.log("result", result);
  return result.data.result;

  // return result.data.result.content;
};

export const generateCompletion = async (
  chunks: ConversationChunk[],
  targetName: string,
  summary: string[] | null
) => {
  const result = await generateCompletionAnthropicFunction({
    conversationChunks: chunks,
    targetName: targetName,
    summary,
  });
  // console.log(result, result.data.result.content);
  // return result.data.result.content;
  return result.data.result;
};
